<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="footer">
    <div class="top">
      <div class="con">
        <div class="title">联系我们</div>
        <div class="w">
          <!-- <div class="l">服务热线:029-85365810</div> -->
          <div class="l">服务热线:13856990809</div>
          <div class="r">公司地址:深圳市福田区莲花街道福新社区益田路6013号江苏大厦A、B座A座17层1702</div>
        </div>
      </div>
    </div>
    <div class="down">Copyright ◎ 2023-2033 iinli. All Rights Reserved 粤ICP备2024209091号-1</div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  background: #F6F9FE;
  opacity: 1;
  .top {
    height: 150px;
    width: 1200px;
    margin: 0 auto;
    .con {
      .title {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        border-bottom: 1px solid #333;
        padding: 25px 0 20px 0;
      }
      .w {
        padding: 16px 0 34px 0;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        display: flex;
        .r {
          margin-left: auto;
        }
      }
    }
  }
  .down {
    height: 63px;
    background: #3D3D3D;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    text-align: center;
    line-height: 63px;
  }
}
</style>
